import { Component } from '@angular/core';
import example from 'data/example.json';
import { Game } from 'src/app/lib/game.library';
import { Puzzle } from 'src/app/lib/interface.library';
import {
    parseLichessGames,
    parseLichessStudies
} from 'src/app/lib/util.library';

@Component({
    selector: 'app-auto-generated-puzzles',
    templateUrl: './auto-generated-puzzles.component.html',
    styleUrls: ['./auto-generated-puzzles.component.css']
})
export class AutoGeneratedPuzzlesComponent {
    private _autoGeneratedPuzzles: Puzzle[];
    constructor() {
        this.autoGeneratedPuzzles = parseLichessGames(example.example);
        for (let puzzle of this.autoGeneratedPuzzles) {
            let node = puzzle.pgn.nextNodes[0];
            let game = new Game();
            while (
                node.nextNodes[0] &&
                node.nextNodes[0].move.charAt(
                    node.nextNodes[0].move.length - 1
                ) !== '#'
            ) {
                console.log('move', node.move);
                game.makeMove(node.move);

                // console.log(game.getLegalMoves());

                node = node.nextNodes[0];
            }
            if (
                !node.nextNodes[0] ||
                node.nextNodes[0].move.charAt(
                    node.nextNodes[0].move.length - 1
                ) !== '#'
            ) {
                console.error(
                    "our puzzle was supposed to lead to mate, and for some reason, it didn't",
                    puzzle
                );
            } else {
                puzzle.beginAt = node;
            }
        }
        // console.log('autoGeneratedpuzzles', this.autoGeneratedPuzzles);
    }
    get autoGeneratedPuzzles(): Puzzle[] {
        return this._autoGeneratedPuzzles;
    }
    set autoGeneratedPuzzles(puzzles: Puzzle[]) {
        this._autoGeneratedPuzzles = puzzles;
    }
}
